import type { ComponentPropsWithoutRef } from 'react';

import clsx from 'clsx';
type GenerationPlaceholderProps = { placeholderText: string } & ComponentPropsWithoutRef<'div'>;

export function GenerationPlaceholder({
    placeholderText,
    className,
    ...restProps
}: GenerationPlaceholderProps) {
    return (
        <div className={clsx('flex flex-col space-y-4', className)} {...restProps}>
            {placeholderText ? <span className="text-left text-sm">{placeholderText}</span> : null}
            {[1, 2, 3, 4, 5].map((el) => (
                <span
                    key={el}
                    className="block h-1.5 w-full animate-pulse rounded-full bg-icoGray-300 dark:bg-icoDarkMode-anthracite"
                />
            ))}
        </div>
    );
}
